import { render, staticRenderFns } from "./SgsTop.vue?vue&type=template&id=b0c4e15c&scoped=true"
import script from "./SgsTop.vue?vue&type=script&lang=js"
export * from "./SgsTop.vue?vue&type=script&lang=js"
import style0 from "./SgsTop.vue?vue&type=style&index=0&id=b0c4e15c&prod&lang=scss&scoped=true"
import style1 from "./SgsTop.vue?vue&type=style&index=1&id=b0c4e15c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c4e15c",
  null
  
)

export default component.exports